/**
 * Alerts Page
 * Multi-column alert feed layout (aggr.trade style)
 */

import { PriceBar } from '@/components/dashboard/price-bar';
import { AlertColumn, type ColumnConfig } from '@/components/dashboard/alert-column';

const COLUMNS: readonly ColumnConfig[] = [
  { id: 'trades', title: 'Large Trades', types: ['large_trade'], includeTrades: true },
  { id: 'absorption', title: 'Absorption', types: ['absorption'] },
  { id: 'sweeps', title: 'Sweeps & Liq', types: ['sweep'] },
  { id: 'pivots', title: 'Pivots Signals', types: ['ORDER_FLOW_SIGNAL', 'brain_signal', 'pro_trader_signal', 'agent_signal', 'order_flow_agent_signal'] },
  { id: 'signals', title: 'Signals', types: ['signal', 'exchange_dominance', 'twap', 'cvd_spike'] },
] as const;

export function AlertsPage() {
  return (
    <div className="flex h-[calc(100vh-3.5rem)] flex-col">
      {/* Compact price bar */}
      <PriceBar />

      {/* Column grid - fills remaining height */}
      {/* Desktop: 5 equal columns with 1px dividers. Mobile: horizontal scroll */}
      <div className="grid flex-1 grid-cols-5 gap-px overflow-hidden bg-border max-lg:flex max-lg:overflow-x-auto">
        {COLUMNS.map((col) => (
          <div key={col.id} className="min-h-0 min-w-0 max-lg:min-w-[280px] max-lg:flex-shrink-0">
            <AlertColumn config={col} />
          </div>
        ))}
      </div>
    </div>
  );
}
